import FoxifyCard from "@components/foxifyCard";
import Page from '@modules/page'
import React, {useEffect, useState} from "react"
import {Layout, Card, TextField, Button, FormLayout, Link, Badge} from "@shopify/polaris"
import API from "@helpers/api"
import {showToast} from "@plugins/toast"
import Table from "@modules/table"
import {format, compareAsc} from 'date-fns'
import {useAuthStore} from "@container/Auth"
import axios from "@plugins/axios"
import {showConfirm} from "@plugins/confirm"

const License = () => {
	const [loading, setLoading] = useState(false)
	const [code, setCode] = useState('')
	const [shopLicenses, setShopLicenses] = useState([])

	const {licenses, updateShopData, license_active} = useAuthStore()

	useEffect(() => {
		setShopLicenses(licenses)
		localStorage.setItem("license_active", license_active)
	}, [licenses])

	const handleSubmit = () => {
		setLoading(true)
		API.get('shop/validate-purchase', {
			code: code
		}).then(res => {
			console.log(res)
			if (res.ok) {
				if (!licenses.find(license => license._id === res.payload._id)) {
					updateShopData({licenses: [...licenses, res.payload]})
				}
				setCode('')
				showToast({
					message: 'Your purchase code is validated!'
				})
			}
		}).finally(() => setLoading(false))
	}

	const handleDelete = (id) => {
		if (!id) return
		axios.delete(`/api/plugin/license/${id}`)
			.then(response => {
				console.log(response.payload, licenses.filter(license => license._id !== response.payload?._id), 'response')
				if (response.ok) {
					updateShopData({licenses: licenses.filter(license => license._id !== response.payload?._id)})
					showToast({
						message: "License deleted"
					})
				}
			})
			.catch(error => {
				showToast({
					message: error.message,
					error: true
				})
			})
	}

	return (
		<Page
			title="Manage license"
			subtitle={'Use purchase code to un-lock pro features and get our pro service support.'}
			hideBanner
			// primaryAction={!license_active ? {
			// 	content:  'Buy Minimog now',
			// 	onAction: () => window.open(`${process.env.REACT_APP_ITEM_URL}?utm_source=in-app&utm_medium=license-page&utm_campaign=in-app`)
			// } : undefined}
		>
			<Layout>
				<Layout.Section>
					{shopLicenses?.length === 0 && (
						<Card
							title={'Add purchase code'}
							actions={[
								{
									content: 'See instructions',
									onAction: () => window.open('https://docs.minimog.co/getting-started/purchase-code-and-activation')
								}
							]}
						>
							<Card.Section>
								<FormLayout>
									<TextField
										labelHidden
										placeholder={'Enter your purchase code'}
										label={'Enter your purchase code'}
										value={code}
										onChange={v => setCode(v)}
										connectedRight={<Button loading={loading} primary onClick={handleSubmit} disabled={!code}>Validate</Button>}
									/>
								</FormLayout>
							</Card.Section>
						</Card>
					)}
					{shopLicenses?.length > 0 && (
						<Card title={'Licenses'}>
							{shopLicenses?.map((license, index) => {
								console.log(license, 'license')
								const expired = compareAsc(new Date(), new Date(license?.supported_until)) === 1
								return (
									<Card.Section key={index} subdued={index % 2 === 0}>
										<Table>
											<tbody>
											<tr>
												<th width={200}>Purchase code:</th>
												<td><span className={'font-medium'}>{license?.code}</span></td>
											</tr>
											<tr>
												<th width={200}>Item:</th>
												<td><Link url={license?.item_url} external>{license?.item_name}</Link></td>
											</tr>
											<tr>
												<th width={200}>License type:</th>
												<td>{license?.license}</td>
											</tr>
											<tr>
												<th width={200}>Bought at:</th>
												<td>{format(new Date(license?.sold_at), 'yyyy-MM-dd')}</td>
											</tr>
											<tr>
												<th width={200}>Supported until:</th>
												{license.lifetime_support ? (
													<td><Badge status={'success'}>Lifetime</Badge></td>
												) : (
													<td>{license?.supported_until ? format(new Date(license?.supported_until), 'yyyy-MM-dd') : ''}: <Badge status={!expired ? 'success' : undefined}>{expired ? 'Expired' : 'Active'}</Badge></td>
												)}
											</tr>
											</tbody>
										</Table>
										<Button size={'slim'} onClick={() => {
											showConfirm({
												title: `Remove ${license.code}?`,
												message: 'This action can\'t be undone.',
												danger: true,
												confirm: 'Remove'
											}).then(res => {
												if (res) handleDelete(license._id)
											})
										}} destructive>Remove</Button>
									</Card.Section>
								)
							})}
						</Card>
					)}
				</Layout.Section>
			</Layout>
		</Page>
	)
}


export default License
